// @ts-nocheck
import PageLayout from '@components/PageLayout';

import { useSelector } from 'react-redux';

import EyeExamsOverview from '@components/eye-exams/EyeExamsOverview';
import EyeExamsList from '@components/eye-exams/EyeExamsList';

import { RootState } from 'src/store/store';

import { getLabelFallback } from '@utils/utils';

const EyeExams = (): JSX.Element => {
    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const eyeExamsBackLabel = getLabelFallback('MY_APPOINTMENTS_EYE_EXAMS_BACK_CTA_LABEL');
    const eyeExamsLabel = getLabelFallback('MYAPPOINTMENTS_EYE_EXAMS_PAGE_TITLE');
    return (
        <PageLayout
            data_element_id="AccountSummary_Static"
            hideMenu
            labelMenu={eyeExamsLabel}
            backLabel={eyeExamsBackLabel}
        >
            <div className="eye-exams">
                <EyeExamsList />
                <EyeExamsOverview />
            </div>
        </PageLayout>
    );
};

export default EyeExams;
